export default {
  auth0: {
    domain: "worksimply.auth0.com",
    clientId: "LvqfDfdIMmXKYHCjFn743O65HGXUqLzB",
    audience: "api.worksimply.ca",
  },
}
